var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.9143,
    height: 24,
    rx: 10.9571,
    fill: "#6F547D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3870_1605",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 17,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.95715,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3870_1605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29053 7.99967V6.66634C8.29053 6.29967 8.42119 5.98567 8.68253 5.72434C8.94342 5.46345 9.25719 5.33301 9.62386 5.33301H12.2905C12.6572 5.33301 12.9712 5.46345 13.2325 5.72434C13.4934 5.98567 13.6239 6.29967 13.6239 6.66634V7.99967H16.2905C16.6572 7.99967 16.9712 8.13034 17.2325 8.39167C17.4934 8.65256 17.6239 8.96634 17.6239 9.33301V16.6663C17.6239 17.033 17.4934 17.347 17.2325 17.6083C16.9712 17.8692 16.6572 17.9997 16.2905 17.9997H5.62386C5.25719 17.9997 4.94342 17.8692 4.68253 17.6083C4.42119 17.347 4.29053 17.033 4.29053 16.6663V9.33301C4.29053 8.96634 4.42119 8.65256 4.68253 8.39167C4.94342 8.13034 5.25719 7.99967 5.62386 7.99967H8.29053ZM9.62386 7.99967H12.2905V6.66634H9.62386V7.99967ZM16.2905 13.9997H12.9572V15.333H8.95719V13.9997H5.62386V16.6663H16.2905V13.9997ZM10.2905 13.9997H11.6239V12.6663H10.2905V13.9997ZM5.62386 12.6663H8.95719V11.333H12.9572V12.6663H16.2905V9.33301H5.62386V12.6663Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPin);
export default __webpack_public_path__ + "static/media/work_pin.170f2467cb51fb9fcc3a2bfc54037cbd.svg";
export { ForwardRef as ReactComponent };